<template>
  <div class="common-page company-information-management">
    <div class="company-info-box">
      <div class="info-box-left">
        <el-image :src="companyImage" class="info-box-image"></el-image>
        <div class="box-left-box">
          <div class="company-name">{{ companyInfo.companyName }}</div>
          <div class="company-des">
            <span>公司ID：{{ companyInfo.companyId }}</span>
            <span class="line">|</span>
            <span>
              公司地址：{{ companyInfo.provinceName
              }}{{ companyInfo.cityName

              }}{{ companyInfo.districtName }}{{ companyInfo.address }}
            </span>
          </div>
        </div>
      </div>
      <div class="info-box-right">
        <div class="box-right-list">
          <div class="right-list-num">{{ companyInfo.userNum }}</div>
          <div class="right-list-txt">员工数（人）</div>
        </div>
        <div class="box-right-list">
          <div class="right-list-num">{{ companyInfo.runningDriverNum }}</div>
          <div class="right-list-txt">平台在跑司机数（人）</div>
        </div>
        <div class="box-right-list">
          <div class="right-list-num">{{ companyInfo.tempDriverNum }}</div>
          <div class="right-list-txt">临调司机数（人）</div>
        </div>
      </div>
    </div>
    <div class="push-setting-box">
      <div class="setting-title">机构推广设置</div>
      <div class="setting-sub">
        <div class="sub-box">
          <span>允许司机推广：</span>
          <span>开启后，机构内的司机可自主申请成为平台推广员，通过司机推广的货主返佣将直接返还至司机钱包</span>
        </div>
        <div class="sub-operate">
          <div :class="companyInfo.allowedPromotion ? 'open' : 'close'">
            {{ companyInfo.allowedPromotion ? "开启" : "关闭" }}
          </div>
          <el-switch active-color="#13ce66" :value="companyInfo.allowedPromotion" @change="changeSetting"></el-switch>
        </div>
      </div>
      <div class="setting-sub">
        <div class="sub-box">
          <span>机构推广码：</span>
          <span>机构可推荐新货主使用拼满运平台，推荐成功的货主下单后将推广返佣结算至机构</span>
        </div>
        <div class="sub-operate">
          <div class="qr-box">
            <el-image
              :src="companyInfo.promotionQr"
              class="qr-image"
              v-if="companyInfo.promotionQr"
              :preview-src-list="[companyInfo.promotionQr]"></el-image>
            <div
              class="qr-tip"
              @click="
                exportImage(companyInfo.promotionQr, companyInfo.companyName)
              ">
              点击下载机构推广码
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCompanyInfo,
  settingPromotion,
} from "@/views/SystemManagement/CompanyInformationManagement/api";
import { rollbackDriver } from "@/views/ApprovalCenter/DriverInformationApproval/api";

export default {
  name: "CompanyInformationManagement",
  mixins: [],
  components: {},
  data() {
    return {
      companyInfo: {},

      companyImage: require("@/assets/imgs/company.png"),
      username: localStorage.getItem("username"),
      phone: localStorage.getItem("phone"),
      deptName: localStorage.getItem("deptName"),
      form: {
        allowedPromotion: false,
      },
    };
  },

  created() {
    this.getCompanyInfo();
  },
  mounted() {},
  methods: {
    changeSetting(val) {
      let str = val
        ? "开启后，机构内的司机可自主申请成为平台推广员，通过司机推广的货主返佣将直接返还至司机钱包，是否确认开启？"
        : "关闭后，司机将无法进行个人推广工作，但司机已推广的货主下单仍然会返佣至司机，是否确认关闭？";
      this.$confirm(`${str}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        settingPromotion({
          allowedPromotion: val ? true : false,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("设置成功");
            this.getCompanyInfo();
          }
        });
      });
    },
    getCompanyInfo() {
      getCompanyInfo().then((res) => {
        if (res.code === 200) {
          this.companyInfo = res.data;
          if (res.data.promotionQr) {
            this.companyInfo.promotionQr =
              "data:image/png;base64," + res.data.promotionQr;
          }
          // // console.log("asdfasdfasdf", this.companyInfo);
        }
      });
    },
    // base64格式的图片
    dataURLtoBlob(dataurl) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = window.atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    // 将blob对象转化成文件并导出到本地
    saveAs(blob, filename) {
      let link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },

    // 将base64格式的图片下载到本地
    exportImage(base64Str, filename) {
      let blob = this.dataURLtoBlob(base64Str);
      this.saveAs(blob, filename);
    },
  },
};
</script>
<style lang="scss" scoped>
.company-information-management {
  padding: 0.2rem;
  box-sizing: border-box;
  display: flex;
  .company-info-box {
    width: 100%;
    height: 1.06rem;
    background-color: #ffffff;
    border-radius: 0.08rem;
    display: flex;
    flex-shrink: 0;
    .info-box-left {
      width: 35%;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      .info-box-image {
        width: 0.6rem;
        height: 0.6rem;
        margin: 0 0.2rem;
      }
      .box-left-box {
        .company-name {
          font-size: 0.18rem;
          font-weight: 600;
          line-height: 0.2rem;
          color: #000000;
        }
        .company-des {
          font-size: 0.12rem;
          line-height: 0.2rem;
          padding-top: 0.1rem;
          color: #8c8c8c;
          .line {
            margin: 0 0.06rem;
          }
        }
      }
    }
    .info-box-right {
      flex: 1;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .box-right-list {
        width: 33%;
        text-align: center;
        position: relative;
        .right-list-num {
          font-size: 0.24rem;
          padding-bottom: 0.05rem;
          color: #000000;
          font-weight: 700;
        }
        .right-list-txt {
          font-size: 0.12rem;
          color: #8c8c8c;
        }
      }
      .box-right-list:after {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 0.01rem;
        height: 100%;
        background: #dce5f5;
      }
    }
  }
  .push-setting-box {
    flex: 1;
    margin-top: 0.2rem;
    background-color: #ffffff;
    border-radius: 0.08rem;
    padding: 0.12rem 0.1rem;
    box-sizing: border-box;
    .setting-title {
      font-weight: 600;
      font-size: 0.16rem;
      line-height: 0.24rem;
    }
    .setting-sub {
      .sub-box {
        padding: 0.2rem 0 0.14rem;
        span:nth-of-type(1) {
          color: #434343;
          font-size: 0.14rem;
        }
        span:nth-of-type(2) {
          color: #8c8c8c;
          font-size: 0.12rem;
        }
      }
      .sub-operate {
        .qr-box {
          width: 1.5rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .qr-image {
            width: 1.4rem;
            height: 1.4rem;
          }
          .qr-tip {
            font-size: 0.12rem;
            color: #1269ff;
            padding-top: 0.1rem;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }

        .open {
          display: inline-block;
          padding: 0.04rem 0.06rem;
          background-color: rgba(18, 105, 255, 0.1);
          color: #1269ff;
          font-size: 0.12rem;
          border-radius: 0.02rem;
          margin-right: 0.02rem;
        }
        .close {
          display: inline-block;
          padding: 0.04rem 0.06rem;
          background-color: #eeeeee;
          color: #999999;
          font-size: 0.12rem;
          border-radius: 0.02rem;
          margin-right: 0.02rem;
        }
      }
    }
  }
}
</style>
